module.exports = __webpack_public_path__ + "img/base.cba12937.png";